module.exports = __webpack_public_path__ + "img/cloud.a9b650eb.svg";